module.exports = __webpack_public_path__ + "img/university_5.3cdda648.jpg";